import React from 'react';
import {
    Wrapper,
    Content,
    Controls,
    Title,
    Header,
    InfoGroup,
    Label,
    Info,
    ProductStatus,
    CatalogsCount,
} from './card-product.styles';
import { CardProductProps } from './types';
import { Typography } from '@shared/ui/typography/typography';
import dayjs from 'dayjs';

export const CardProduct: React.FC<CardProductProps> = ({ product, children }) => {
    return (
        <Wrapper>
            <Header>
                <Title size='subtitle2' color='neutral_90'>
                    {product.name}
                </Title>
                <Controls>{children}</Controls>
            </Header>
            <Content>
                <InfoGroup $maxWidth={300}>
                    <Label size='body2_long' color='neutral_50'>
                        Тип продукта
                    </Label>
                    <Info size='body2_long'>{product.type.name}</Info>
                </InfoGroup>
                <InfoGroup $maxWidth={180}>
                    <Label size='body2_long' color='neutral_50'>
                        Дата начала
                    </Label>
                    <Info size='body2_long'>{product.startAt ? dayjs(product.startAt).format('DD.MM.YY') : '-'}</Info>
                </InfoGroup>
                <InfoGroup $maxWidth={180}>
                    <Label size='body2_long' color='neutral_50'>
                        Дата завершения
                    </Label>
                    <Info size='body2_long'>{product.endAt ? dayjs(product.endAt).utc().format('DD.MM.YY') : '-'}</Info>
                </InfoGroup>
                <InfoGroup $maxWidth={270}>
                    <Label size='body2_long' color='neutral_50'>
                        Прикрепление к каталогам
                    </Label>
                    <CatalogsCount>
                        <Typography size='body2_short'>{product.catalogs?.length}</Typography>
                    </CatalogsCount>
                </InfoGroup>
                <InfoGroup $maxWidth={214}>
                    <Label size='body2_long' color='neutral_50'>
                        Состояние продукта
                    </Label>
                    <ProductStatus $active={product.active}>
                        <Typography size='body2_short' color='inherit'>
                            {product.active ? 'Активный' : 'Не активный'}
                        </Typography>
                    </ProductStatus>
                </InfoGroup>
            </Content>
        </Wrapper>
    );
};
